import React from "react"
import styled from "styled-components"
import axios from "axios"
import { navigate } from "gatsby"
import DefaultLinkButton from "../Button/DefaultLinkButton"
import LineArrowRight from "../Icons/LineArrowRight"
import { Form, FormRow, FormTwoCol, FormCol, FormAction } from "../Form"
import StateSelect from "../StateSelect"

const Forms = styled(Form)`
  &.form {
    .css-1wa3eu0-placeholder {
      color: rgba(255, 255, 255, 0.5);
      &:focus,
      &:active {
        border-color: #fff;
      }
    }
    .form-control,
    .css-1uccc91-singleValue {
      color: #fff;
      &::placeholder {
        color: #fff;
      }
      &:focus,
      &:active {
        &::placeholder {
          color: #fff;
        }
      }
    }
    /* Change autocomplete styles in WebKit */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus {
      -webkit-text-fill-color: #fff;
      -webkit-box-shadow: 0 0 0px 1000px transparent inset;
      transition: background-color 5000s ease-in-out 0s;
      box-shadow: 0 0 0px 1000px transparent inset;
    }
  }
`

class ContactForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      source: "",
      page: "",
      form: "",
      name: "",
      email: "",
      phone_no: "",
      state: null,
      zip_code: "",
      message: "",
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleChangeSelect = this.handleChangeSelect.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleChange(event) {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }
  handleChangeSelect(state) {
    this.setState({ state })
  }
  handleSubmit(event) {
    event.preventDefault()
    const { location } = this.props
    const data = {
      source: location.origin,
      page: location.href,
      form: event.target.id,
      full_name: this.state.name,
      email: this.state.email,
      mobile_no: this.state.phone_no,
      state: this.state.state.value,
      zip_code: this.state.zip_code,
      commnet: "Message: " + this.state.message,
      api_token: process.env.GATSBY_FORM_CRM_TOKEN,
    }

    axios({
      method: "post",
      url: "https://crm.senseicrm.com/api/create-lead-wordpress",
      data: data,
      headers: { Authorization: "Bearer " + process.env.GATSBY_FORM_CRM_TOKEN },
    })
      .then(res => {
        this.setState({
          source: "",
          page: "",
          form: "",
          name: "",
          email: "",
          phone_no: "",
          state: "",
          zip_code: "",
          message: "",
        })
        navigate("/thank-you-for-contacting-us/")
      })
      .catch(error => {
        alert(error)
      })
  }
  render() {
    return (
      <form
        id="requestmetalbuilding"
        onSubmit={this.handleSubmit}
        className="requestmetalbuilding"
      >
        <Forms className="form">
          <FormRow>
            <FormTwoCol>
              <div className="form-group">
                <input
                  type="text"
                  id="name"
                  className="form-control"
                  placeholder="Name"
                  onChange={this.handleChange}
                  required
                />
              </div>
            </FormTwoCol>

            <FormTwoCol>
              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Email Address"
                  onChange={this.handleChange}
                  required
                />
              </div>
            </FormTwoCol>
          </FormRow>

          <FormRow>
            <FormCol>
              <div className="form-group">
                <input
                  type="tel"
                  id="phone_no"
                  className="form-control"
                  placeholder="Phone Number"
                  onChange={this.handleChange}
                  pattern="[0-9]{10}"
                  required
                />
              </div>
            </FormCol>
          </FormRow>

          <FormRow>
            <FormTwoCol>
              <div className="form-group form-group-select">
                <StateSelect
                  id="state"
                  value={this.state.state}
                  onChange={this.handleChangeSelect}
                />
              </div>
            </FormTwoCol>
            <FormTwoCol>
              <div className="form-group">
                <input
                  type="number"
                  id="zip_code"
                  className="form-control"
                  placeholder="Zip Code"
                  onChange={this.handleChange}
                  required
                />
              </div>
            </FormTwoCol>
          </FormRow>

          <FormRow>
            <FormCol>
              <div className="form-group form-group-textarea">
                <textarea
                  type="text"
                  id="message"
                  className="form-control"
                  placeholder="Type your message here…"
                  onChange={this.handleChange}
                  required
                  title=" "
                />
              </div>
            </FormCol>
          </FormRow>
          <FormAction className="form-action" justifyContent="flex-end">
            <button type="submit" aria-label="button">
              <DefaultLinkButton
                text="Send Message"
                icon={<LineArrowRight />}
                size="lg"
              />
            </button>
          </FormAction>
        </Forms>
      </form>
    )
  }
}

export default ContactForm
